<template>
  <div v-if="content" id="contact-component">
    <div>
      <h3 class="form-title" v-if="content.title" v-html="content.title"></h3>
      <vue-markdown v-if="content.text" class="form-subtitle">{{content.text}}</vue-markdown>
      <div v-if="error">{{$t('message.error')}}</div>
      <vue-markdown v-if="success" class="success markdown">{{content.success}}</vue-markdown>
      <form v-else ref="form" @submit.prevent="handleContactForm()">
        <div v-if="field('name')" class="input-w">
          <input :placeholder="$t('message.name')" type="text" v-model="form.name" required />
        </div>
        <div v-if="field('firstname')" class="input-w">
          <input
            :placeholder="$t('message.firstname')"
            type="text"
            v-model="form.firstname"
            required
          />
        </div>
        <div v-if="field('number')" class="input-w">
          <input :placeholder="$t('message.number')" type="number" v-model="form.number" required />
        </div>
        <div v-if="field('email')" class="input-w">
          <input :placeholder="$t('message.email')" type="email" v-model="form.email" required />
        </div>
        <!-- <div class="input-w">
          <select placeholder="Choisir le parc" class="select" name="select" v-model="form.parc" required>
            <option value="Ste-Foy">Parc Lyon Ste-Foy</option>
            <option value="Albigny">Parc Lyon Albigny</option>
          </select>
        </div> -->
        <div v-if="field('message')" class="input-w textarea">
          <textarea
            class="area"
            :placeholder="$t('message.message')"
            type="textarea"
            v-model="form.message"
            required
          ></textarea>
        </div>
        <label v-if="field('optin')" class="custom-checkbox">
          <input type="checkbox" v-model="form.optin" />
          <span class="checkmark"></span>
          <p>{{$t('message.optin')}}</p>
        </label>
        <div class="button-w">
          <button type="submit">
            <fai v-if="!loading" class="icon" icon="angle-right" />
            <span v-if="!loading">{{$t('message.submit')}}</span>
            <fai class="icon" v-else icon="spinner" spin />
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/api";
import mail from "@/mixins/mail.js";
export default {
  mixins: [mail],
  props: {
    content: null
  },
  data() {
    return {
      loading: false,
      error: false,
      success: false,
      form: {
        name: "",
        firstname: "",
        email: "",
        message: "",
        optin: false,
      }
    };
  },
  methods: {
    field(name) {
      if (this.content.fields.indexOf(name) > -1) {
        return true;
      }
      return false;
    },
    formatTags(tags) {
      return tags.map(tag => {
        return {
          TagCategoryCode: "CAV",
          Label: tag.name
        };
      });
    },
    sanitize(body) {
      Object.keys(this.form).map(val => {
        body = body.replace(`[${val}]`, this.form[val]);
      });
      return body;
    },
    handleContactForm() {
      console.log(this.formatTags(this.content.tags));
      console.log('handle contact')
      this.loading = true;
      axios({
        method: "post",
        url: "https://app-koban.com/api/v1/ncThird/PostMany",
        params: {
          uniqueproperty: "Email"
        },
        headers: {
          "X-ncApi": "BrcK2JIYGuCx9cOtiJuWr6hP",
          "X-ncUser": "Y8nagITZFoo29w0t1EV8z2Yp",
          "Content-Type": "application/json"
        },
        data: [
          {
            Label: "Le label",
            Status: {
              Label: "Client",
              Code: "CLI"
            },
            Type: {
              Label: "Particulier",
              Code: "PART"
            },
            Optin: this.form.optin,
            EMail: this.form.email,
            Name: this.form.name,
            Firstname: this.form.firstname,
            Tags: this.formatTags(this.content.tags)
          }
        ]
      })
        .then(res => {
          this.success = true;
          this.error = false;
          this.loading = false;
          console.log(res)
          this.mail(
            this.content.mailTo,
            this.sanitize(this.content.subject),
            this.sanitize(this.content.body)
          );
        })
        .catch(e => {

          this.error = true;
          this.success = false;
          this.loading = false;
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss">
#contact-component {
  .success {
    text-align: center;
    color: $primary;
    margin: auto;
    font-size:25px;
  }
  input {
    border: 1px solid #bbb !important;
  }
  .area {
    height: 150px;
  }
  .custom-checkbox {
    p {
      color: black;
    }
  }
  .form-title,
  .form-subtitle {
    text-align: center;
    padding: 1em 0;
  }

  h2 {
    text-align: center;
    color: #fff;
    padding: 50px 0;
  }

  select {
    appearance: none;
  }

  form {
    width: 400px;
    margin: auto;
    max-width: 100%;
    .input-w {
      width: 100%;
      display: block;
      margin-bottom: 15px;
      input,
      textarea,
      select {
        display: block;
        width: 100%;
        padding: 15px 20px;
        border-radius: 30px;
        font-family: "Quicksand", sans-serif;
        font-size: 13px;
      }
    }
    .button-w {
      display: block;
      padding: 20px 0;
      text-align: center;
      button {
        display: flex;
        align-items: center;
        margin: auto;
        padding: 15px 20px;
        border-radius: 30px;
        border: none;
        background-color: #fff;
        justify-content: center;
        font-size: 12px;
        text-transform: uppercase;
        font-family: "Luckiest Guy", cursive;
        box-shadow: 2px 2px 12px 5px rgba(0, 0, 0, 0.17);
        cursor: pointer;
        .icon {
          color: $primary;
          font-size: 250%;
          margin-right: 8px;
        }
        span {
          color: $primary;
        }
      }
    }
  }
}
</style>
